module.exports = __webpack_public_path__ + "img/sport-hero.766f8a17.jpg";